
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ENVIRONMENT } from '../../environments/environment';

import { BaseService } from './base.service';

@Injectable()
export class BondService {
  constructor(
    private baseService: BaseService,
    private http: HttpClient,
  ) {
  }

  getEsbnBank(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/banks';
    return this.baseService.get(url);
  }

  getEsbnOccupation(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/occupations';
    return this.baseService.get(url);
  }

  getEsbnProvince(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/provinces';
    return this.baseService.get(url);
  }

  getEsbnCity(provinceId: string): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/provinces/' + provinceId + '/cities';
    return this.baseService.get(url);
  }

  getEsbnGender(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/genders';
    return this.baseService.get(url);
  }

  getEsbnSubregistry(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/subregistries';
    return this.baseService.get(url);
  }

  getMemberCustodianData() {
    const url = ENVIRONMENT.service.bond + '/investors/custodian/me?force=true';
    return this.baseService.get(url);
  }

  getEsbnTransactionStatus(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/transaction_statuses';
    return this.baseService.get(url);
  }

  getEsbnOffer(): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/series/offer';
    return this.baseService.get(url);
  }

  getEsbnOfferbySid(sid: any): Observable<any> {
    const url = ENVIRONMENT.service.bond + '/series/offer/' + sid;
    return this.baseService.get(url);
  }

  getInvestorOrderList(sid: string) {
    const url = ENVIRONMENT.service.bond + '/investors/' + sid + '/orders';
    return this.baseService.get(url);
  }

  EsbnSeriesOrder(body: any) {
    const url = ENVIRONMENT.service.bond + '/orders';
    return this.baseService.post(url, body);
  }

  registerMemberCustodianData(investorDetail: any) {
    const body = {
      name: investorDetail.investorName,
      id_no: investorDetail.investorIdentityNumber,
      tax_no: investorDetail.investorTaxNumber,
      place_of_birth: investorDetail.investorBirthPlace,
      date_of_birth: investorDetail.investorBirthDate,
      gender_id: investorDetail.investorGender,
      occupation_id: investorDetail.investorOccupation,
      address: investorDetail.investorAddress,
      city_id: investorDetail.investorCity,
      province_id: investorDetail.investorProvince,
      phone: investorDetail.investorHomePhoneNumber,
      mobile_phone: investorDetail.investorPhoneNumber,
      email: investorDetail.investorEmail,
      zip_code: investorDetail.investorAddressZipCode,
      country_of_birth: investorDetail.investorBirthCountry,
      religion_id: investorDetail.investorReligion,
      marital_status_id: investorDetail.investorMaritalStatus,
      employment_annual_income_id: investorDetail.investorIncomePerAnnum,
      education_id: investorDetail.investorEducationBackground,
      investment_objectives_id: investorDetail.investorInvestmentObjectives,
      business_company_name: investorDetail.investorCompanyName,
      business_address: investorDetail.investorCompanyAddress,
      business_company_city_id: investorDetail.investorCompanyCity,
      business_company_province_id: investorDetail.investorCompanyProvince,
      business_company_country: investorDetail.investorCompanyCountry,
      business_industry: investorDetail.investorCompanyBusiness,
      employment_title: investorDetail.investorCompanyPosition,
      employment_annual_income: investorDetail.investorIncomePerAnnum,
      source_of_funds_id: investorDetail.investorSourceOfFund,
      spouse_name: investorDetail.investorSpouseName,
      mother_maiden_name: investorDetail.investorMotherMaidenName,
      investment_objectives: investorDetail.investorInvestmentObjectives,
      funds_acc_bank_id: investorDetail.investorFundAccountBankName,
      funds_acc_account_no: investorDetail.investorFundAccountNumber,
      funds_acc_account_name: investorDetail.investorFundAccountName
    };
    for (const prop in body) {
      if (body.hasOwnProperty(prop) && (body[prop] === null || body[prop] === '')) {
        delete body[prop];
      }
    }
    const url = ENVIRONMENT.service.bond + '/investors/custodian/me';
    return this.baseService.post(url, body);
  }

  updateEsbnInvestorDetail(investorDetail: any, sid: string, fundAccountId: number, securitiesAccountId: number) {
    const body = {
      sid: investorDetail.investorSID,
      name: investorDetail.investorName,
      id_no: investorDetail.investorIdentityNumber,
      place_of_birth: investorDetail.investorBirthPlace,
      date_of_birth: investorDetail.investorBirthDate,
      province_id: investorDetail.investorProvince,
      gender_id: investorDetail.investorGender,
      occupation_id: investorDetail.investorOccupation,
      city_id: investorDetail.investorCity,
      address: investorDetail.investorAddress,
      phone: investorDetail.investorHomePhoneNumber,
      mobile_phone: investorDetail.investorPhoneNumber,
      email: investorDetail.investorEmail,
      funds_acc_id: fundAccountId,
      securities_acc_id: securitiesAccountId,
      funds_acc_bank_id: investorDetail.investorFundAccountBankName,
      funds_acc_account_no: investorDetail.investorFundAccountNumber,
      funds_acc_account_name: investorDetail.investorFundAccountName,
      securities_acc_subregistry_id: investorDetail.investorSecuritiesSubRegistry,
      securities_acc_participant_id: investorDetail.investorSecuritiesAccountParticipantName,
      securities_acc_account_no: investorDetail.investorSecuritiesAccountNumber,
      securities_acc_account_name: investorDetail.investorSecuritiesAccountName
    };
    for (const prop in body) {
      if (body.hasOwnProperty(prop) && (body[prop] === null || body[prop] === '')) {
        delete body[prop];
      }
    }
    const url = ENVIRONMENT.service.bond + '/investors/complete/' + sid;
    return this.baseService.put(url, body);
  }

  registerEsbnDetail(investorDetail: any) {
    const body = {
      sid: investorDetail.investorSID,
      name: investorDetail.investorName,
      id_no: investorDetail.investorIdentityNumber,
      place_of_birth: investorDetail.investorBirthPlace,
      date_of_birth: investorDetail.investorBirthDate,
      gender_id: investorDetail.investorGender,
      occupation_id: investorDetail.investorOccupation,
      province_id: investorDetail.investorProvince,
      city_id: investorDetail.investorCity,
      address: investorDetail.investorAddress,
      phone: investorDetail.investorHomePhoneNumber,
      mobile_phone: investorDetail.investorPhoneNumber,
      email: investorDetail.investorEmail,
      funds_acc_bank_id: investorDetail.investorFundAccountBankName,
      funds_acc_account_no: investorDetail.investorFundAccountNumber,
      funds_acc_account_name: investorDetail.investorFundAccountName,
      securities_acc_subregistry_id: investorDetail.investorSecuritiesSubRegistry,
      securities_acc_account_no: investorDetail.investorSecuritiesAccountNumber,
      securities_acc_account_name: investorDetail.investorSecuritiesAccountName
    };
    for (const prop in body) {
      if (body.hasOwnProperty(prop) && (body[prop] === null || body[prop] === '')) {
        delete body[prop];
      }
    }
    const url = ENVIRONMENT.service.bond + '/investors/complete';
    return this.baseService.post(url, body);
  }

  updateEsbnInvestorRedemption(investorSID: string, orderCode: string, nominal: number) {
    const body = {
      order_code: orderCode,
      sid: investorSID,
      nominal: nominal
    };
    const url = ENVIRONMENT.service.bond + '/redemptions';
    return this.baseService.post(url, body);
  }

  getSBNSeriesQuota(investorSID: string, seriesID: number) {
    const url = ENVIRONMENT.service.bond + '/investors/' + investorSID + '/series_quota/' + seriesID;
    return this.baseService.get(url);
  }

}


